module.exports = __webpack_public_path__ + "static/media/payslip.451698bb.svg";